<app-page-shell>
  <p-toast></p-toast>

  @if (row(); as merchandiser) {
    <app-page-hero [eyebrow]="'CRM Merchandiser ' + (merchandiser.merchandiserNumber || '')" [title]="merchandiser.name" [subtitle]="(merchandiser.emailAddress || '-') + ' / ' + (merchandiser.mobileNumber || merchandiser.phoneNumber || '-')" [auditStamp]="{ createdAt: merchandiser.createdAt, updatedAt: merchandiser.updatedAt }">
      <div actions>
        <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" (click)="back()"></p-button>
        <p-button label="Edit" icon="pi pi-pencil" (click)="edit()"></p-button>
      </div>
    </app-page-hero>

    <app-page-data-panel title="Merchandiser Profile" [resultText]="merchandiser.active === false ? 'Inactive' : 'Active'">
      <div class="grid">
        <div class="col-12 md:col-3">
          <div class="text-xs text-500">Number</div>
          <div class="font-semibold">{{ merchandiser.merchandiserNumber || '-' }}</div>
        </div>
        <div class="col-12 md:col-3">
          <div class="text-xs text-500">Employee Code</div>
          <div class="font-semibold">{{ merchandiser.employeeCode || '-' }}</div>
        </div>
        <div class="col-12 md:col-3">
          <div class="text-xs text-500">Region</div>
          <div class="font-semibold">{{ merchandiser.region || '-' }}</div>
        </div>
        <div class="col-12 md:col-3">
          <div class="text-xs text-500">Status</div>
          <p-tag [value]="merchandiser.active === false ? 'Inactive' : 'Active'" [severity]="merchandiser.active === false ? 'warn' : 'success'"></p-tag>
        </div>
        <div class="col-12 md:col-3">
          <div class="text-xs text-500">Email</div>
          <div class="font-semibold">{{ merchandiser.emailAddress || '-' }}</div>
        </div>
        <div class="col-12 md:col-3">
          <div class="text-xs text-500">Phone</div>
          <div class="font-semibold">{{ merchandiser.phoneNumber || '-' }}</div>
        </div>
        <div class="col-12 md:col-3">
          <div class="text-xs text-500">Mobile</div>
          <div class="font-semibold">{{ merchandiser.mobileNumber || '-' }}</div>
        </div>
        <div class="col-12">
          <div class="text-xs text-500">Notes</div>
          <div class="font-semibold">{{ merchandiser.notes || '-' }}</div>
        </div>
      </div>
    </app-page-data-panel>
  } @else {
    <app-page-data-panel title="Merchandiser" subtitle="Loading merchandiser details."></app-page-data-panel>
  }
</app-page-shell>
